// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MonthlyEmployeeForecast  {
    _originalTypeClassName = "Loom.BO.MonthlyEmployeeForecast";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MonthlyEmployeeForecast.translate = translateService;
}
this.Projects = [];
this.Id = null;
this.Month = null;
this.Notes = null;
this.ForecastTotal = null;
this.EmployeeId = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Month:any;
Notes:any;
ForecastTotal:any;
EmployeeId:any;
Employee:any;
Projects:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setProjects = ($this, items) => {
                if (items == null) items = [];
                if ($this.Projects == null) $this.Projects = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Projects.length > 0) {
                    Domain.MonthlyEmployeeForecast.removeProjects($this, $this.Projects[0]);
                }

                Domain.MonthlyEmployeeForecast.addManyProjects($this, copyItems);
            }
static addManyProjects = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.MonthlyEmployeeForecast.addProjects($this, items[i]);
                }
            }
static addProjects = ($this, item) => {
                if ($this.Projects == null) $this.Projects = [];
                if (item == null || $this.Projects.indexOf(item) > -1) return;
                $this.Projects.push(item);
if (item.Forecast != $this) {
Domain.ProjectForecast.setForecast(item, $this);
}
}
static addRangeProjects = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.MonthlyEmployeeForecast.addProjects($this, item));
            }
static removeProjects = ($this, item) => {
                if ($this == null || $this.Projects == null || $this.Projects.indexOf(item) === -1) return;
                var _index = $this.Projects.indexOf(item);
                $this.Projects.splice(_index, 1);
item.Forecast = null;
}
static clearProjects = ($this) => { $this.Projects = null; }

static GetEmployeeId($this: any): any{return $this?.Employee?.Employee?.Id;
}
static GetForecastTotal($this: any): any{return $this?.Projects?.linq?.sum((a) => a?.ForecastedEffort);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}